class ReadMore extends HTMLElement {
  constructor() {
    super();
    this.button = this.querySelector("button");
    this.button.addEventListener('click', (event) => {
      event.preventDefault();
      const content = this.querySelector("[data-content]");
      const button = this.querySelector("[data-button]");
      const expand = this.querySelector("[data-expand]");
      const collapse = this.querySelector("[data-collapse]");
      const contentClasses = content.classList;
      
      if (content) {
        contentClasses.toggle('less-content');
        if (contentClasses.contains('less-content')) {
          button.classList.remove('minus');
          button.innerHTML = expand.innerHTML;
        }else{
          button.classList.add('minus');
          button.innerHTML = collapse.innerHTML;
        }
      }
    });
  }
}
  
customElements.define('read-more', ReadMore);
  
  